<div class="flex h-dvh w-screen flex-col overflow-hidden relative">
  <mat-sidenav-container class="flex-1 flex flex-col">
    <mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="!isMobile()"
      class="bg-[#031E57] shell-sidenav rounded-none">
      <app-sidebar [isMobile]="isMobile()" (close)="sidenav.close()" />
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="w-full h-[100dvh] flex flex-col">
        <app-topbar [isMobile]="isMobile()" (toggleMenu)="sidenav.toggle()"/>
        <ngx-loading-bar [includeSpinner]="false" [fixed]="false" [color]="'#52abae'" [height]="'4px'" />

        <div class="flex-1 overflow-y-auto">
          <div class="container py-6 h-full">
            <router-outlet />
          </div>
        </div>
      </div>

    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
